function changecolor(id){
if(!$('#'+id).hasClass("color-hover")){
  $('.toggle-top-menu').removeClass('color-hover');
    
  $('#'+id).addClass('color-hover');
}else{
   $('.toggle-top-menu').removeClass('color-hover');
}
}

function openModal() {
  document.getElementById('myModal').style.display = "block";
}

function closeModal() {
  document.getElementById('myModal').style.display = "none";
}

var slideIndex = 1;
showSlides(slideIndex);

function plusSlides(n) {
  showSlides(slideIndex += n);
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("mySlides");
  var dots = document.getElementsByClassName("demo");
  var captionText = document.getElementById("caption");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
  }
  if(typeof slides[slideIndex-1] !== 'undefined' ){
  slides[slideIndex-1].style.display = "block";
  dots[slideIndex-1].className += " active";
  }
 
}




  
$(window).scroll(function() {
  


 if ($(this).scrollTop()>75)
     {
        $('#top-row-hide').hide('slow');
 
     }
    else
     {
      $('#top-row-hide').show('slow');
    
     }



  
  if ($(window).scrollTop() >= (($(document).height() - $(window).height()) - $('#footer').innerHeight())) {
  var heightcheck=($(window).scrollTop() - (($(document).height() - $(window).height()) - $('#footer').innerHeight()));
    if(heightcheck > 1) {
    var elem=document.getElementById("sidebar");
      setCssTextStyle(elem, "margin-bottom", heightcheck+"px !important");
    }
  }

});

function setCssTextStyle(el, style, value) {
//   var result = el.style.cssText.match(new RegExp("(?:[;\\s]|^)(" +
//       style.replace("-", "\\-") + "\\s*:(.*?)(;|$))")),
//     idx;
//   if (result) {
//     idx = result.index + result[0].indexOf(result[1]);
//     el.style.cssText = el.style.cssText.substring(0, idx) +
//       style + ": " + value + ";" +
//       el.style.cssText.substring(idx + result[1].length);
//   } else {
//     el.style.cssText += " " + style + ": " + value + ";";
//   }
}
